<template>
  <div class="performanceDoingBox">
    <div class="notarizeSearch">
      <span class="fl">合同名称</span>
      <el-input v-model="notarizeName" placeholder="输入合同名称"></el-input>
      <span class="search">
        <img src="@assets/images/warning/search_icon_pre.png" @click="searchFn"/>
      </span>
    </div>
    <div style="position:relative;">
    <!-- <template v-if="listsTable.length <5">
      <Analysis :className="'performanceDoing'" :btnTop="'9px'" :btnLeft="'95%'" :textTop="'-46px'" :textLeft="'69.2%'">
           <p>【查看详情】：点击可查看该履约任务的详细内容。并可在其中进行状态标记和催告申请与管理。</p>
        <p>&nbsp;&nbsp;【申请强执】：对于经公证处3次催告仍违约的订单，金融机构可以选择申请强执公证。金融机构后续可使用该公证向地方法院申请执行。</p>
    </Analysis>
    </template> 
    <template >
      <Analysis :className="'performanceDoing'" :btnTop="'9px'" :btnLeft="'95%'" :textTop="'28px'" :textLeft="'auto'" :textRight="'0px'">
           <p>【查看详情】：点击可查看该履约任务的详细内容。并可在其中进行状态标记和催告申请与管理。</p>
        <p>&nbsp;&nbsp;【申请强执】：对于经公证处3次催告仍违约的订单，金融机构可以选择申请强执公证。金融机构后续可使用该公证向地方法院申请执行。</p>
    </Analysis>
    </template> -->
    <el-table
        :data="listsTable"
        style="width: 100%;margin-bottom:10px;"
        border
        header-cell-class-name="cellCustomer headerCellCustomer ft14"
        cell-class-name="cellCustomer ft12"
    >
      <template slot="empty">
        <img class="data-pic" src="@assets/images/H5/null.png" alt/>
        <br/>暂无数据
      </template>
      <el-table-column prop="taskName" label="履约任务" width="200"></el-table-column>
      <el-table-column prop="contractName" label="合同名称" width="100"></el-table-column>
      <el-table-column prop="notarizationName" label="公证名称" width="100"></el-table-column>
      <el-table-column prop="taskStatus" label="履约状态" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.taskStatus == 1" class="font-status-success">正常</span>
          <span v-if="scope.row.taskStatus == 2" class="font-status-danger">违约</span>
        </template>
      </el-table-column>
      <el-table-column prop="notPerformCount" label="违约期数" width="100"></el-table-column>
      <el-table-column prop="urgeSueCount" label="催告申请数" width="100"></el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="dealWith(scope.row.contractId)" type="text" size="small">
            <span>查看详情</span>
          </el-button>
          <el-button type="text" size="small" v-if="(scope.row.type == 4 && scope.row.taskStatus == 2) ||  scope.row.urgeSueCount > 2">
            <span class="font-status-danger" @click="checkisExecutionApplyNotar(scope.row.taskId, scope.row)">申请强执</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <!-- <PageSize
      v-if="total"
      :currentPage="currentPage"
      :total="total"
      :pageSizes="pageSizes"
      :pageSize="pageSize"
      :page="'pages'"
      :size="'size'"
      class="pageDev"
    />-->
    <el-pagination
        style="float:right"
        @current-change="getMessage"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size.sync="pageSize"
        layout="sizes, prev, pager, next"
        :total="total"
        v-if="total>10"
    ></el-pagination>
    <Dialog
        v-if="actionItem"
        :visible="applyNotars"
        :dialogTitle="'强执公证'"
        v-on:closeDialog="closeDialogs"
        :width="'614px'"
      >
        <div slot="dialog">
           <ExecutionApplyNotar @closeDialog="closeDialogs" @successMessageFn="successMessageFn" :checkExecutionInfo="checkExecutionInfo" :taskType="actionItem.type"></ExecutionApplyNotar>
        </div>
      </Dialog>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
import Dialog from "@common/Dialog.vue";
import ExecutionApplyNotar from "../../../service/components/writeProcedure/fqExecution/ExecutionApplyNotar.vue";
import Analysis from "@common/Analysis.vue";
import {mapState} from "vuex"
export default {
  data() {
    return {
      currentPage: 1, //默认第一页
      total: 0, //总条数
      pageSizes: [10, 20, 50, 100, 200], //每页展示多少条
      pageSize: 10, //默认第一页展示10条
      listsTable: [],
      notarizeName: "", //合同名称,
      applyNotars:false,//申请强制
      checkExecutionInfo:{},
      actionItem: null
    };
  },
  methods: {
      //申请强制-成功
    successMessageFn(flag){
      if(flag){
        this.closeDialogs();
      }
    },
    //是否可以申请强执
    checkisExecutionApplyNotar(id, item){
      this.actionItem = item;
      BaseApi.createRpcToken("/notaryApply/checkQzNotaryApply", {contractPerformTaskId:id})
      .then(
        data => {
          console.log(data)
          if(data.code == 200){
            this.checkExecutionInfo=data.datas;
            this.checkExecutionInfo.contractPerformId=id//履约id
            if(data.datas.isPass){
              this.applyNotars=true
            }else{
              this.$message.error(data.datas.message);
            }
          }
        })
    },
    closeDialogs(){
      this.applyNotars=false;
    },
    getMessage() {
      var queryStr = {
        status: "0,1",
        contractName: this.notarizeName,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      if (this.notarizeName) queryStr.contractName = this.notarizeName;
      BaseApi.createRpcToken("/perform/v2/performList", queryStr)
          .then(
              data => {
                if (data.datas) {
                  this.listsTable = data.datas.result.list;
                  this.total = data.datas.result.totalRow || 80;
                  for (let i = 0; i < this.listsTable.length; i++) {
                    if (this.listsTable[i].startDate != "") {
                      this.listsTable[i].startDate = this.listsTable[i].startDate.split(" ")[0];
                    }
                    if (this.listsTable[i].endDate != "") {
                      this.listsTable[i].endDate = this.listsTable[i].endDate.split(" ")[0];
                    }
                  }
                } else {
                  this.listsTable = [];
                }
              },
              data => {
                this.listsTable = [];
              }
          )
          .catch(function (e) {
            errorLog(e);
          });
    },
    searchFn() {
      var this_1 = this;
      this_1.getMessage();
    },
    evidenceFn(id) {
      this.$router.push({
        path: "details",
        query: {
          id: id
        }
      });
    },
    dealWith(id) {
      this.$router.push({
        path: "mission",
        query: {
          id: id
        }
      });
    }
  },
  components: {
    Dialog,
    ExecutionApplyNotar,
    Analysis
  },
  created() {
    this.getMessage();
  },
  computed: {
    ...mapState(['currentInfo']),
  },
  watch: {
    "currentInfo"(data) {
      this.getMessage()
    }
  }
};
</script>
<style lang="scss">
.el-table__body, .el-table__footer, .el-table__header {
  table-layout: auto !important;
  border-collapse: separate;
}

.performanceDoingBox {
  height: 100%;
  width: 100%;

  .signatoryItem {
    padding: 0 10px 0 10px;
  }

  .listButton {
    .active {
      display: none;
    }

    .normal {
      display: inline-block;
      vertical-align: middle;
    }

    &:hover {
      .active {
        display: inline-block;
        vertical-align: middle;
      }

      .normal {
        display: none;
      }

      .buttonColor {
        color: red;
      }
    }
  }

  .notarizeSearch {
    width: 100%;
    margin-bottom: 20px;
    overflow: hidden;
    font-size: 14px;
    color: #646464;
    line-height: 30px;

    .el-input {
      height: 30px;
      margin-right: 10px;
      float: left;
      margin-left: 6px;

      .el-input__inner {
        height: 30px;
        line-height: 28px;
        border-radius: 0;
      }

      .el-input__icon {
        line-height: 28px;
      }
    }

    .el-input:nth-child(1),
    .el-input:nth-child(2) {
      width: 180px;
    }

    .el-input:nth-child(3) {
      width: 135px;
    }

    .el-select {
      float: left;

      .el-input {
        width: 107px;
      }
    }

    .search {
      width: 30px;
      height: 30px;
      float: left;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  table {
    width: 100% !important;
    // border-collapse: none;
    table-layout: auto;
    // th,
    // td {
    //   vertical-align: middle;
    //   height: 30px;
    //   padding: 0;
    // }
    // th:nth-child(1),
    // td:nth-child(1) {
    //   width: 26.1%;
    // }
    // th:nth-child(2),
    // td:nth-child(2) {
    //   width: 16.8%;
    // }
    // th:nth-child(3),
    // td:nth-child(3) {
    //   width: 17.6%;
    // }
    // th:nth-child(4),
    // td:nth-child(4) {
    //   width: 12%;
    // }
    // th:nth-child(5),
    // td:nth-child(5) {
    //   width: 10.8%;
    // }
    // th:nth-child(6),
    // td:nth-child(6) {
    //   width: 16.7%;
    // }
    // th {
    //   font-size: 14px;
    //   color: #505050;
    //   text-align: center;
    //   background: #f9f9f9;
    // }
    // td {
    //   font-size: 12px;
    //   color: #969696;
    //   text-align: center;
    //   img {
    //     vertical-align: middle;
    //     margin-right: 4px;
    //   }
    // }
    // .cell {
    //   text-align: center;
    //   line-height: 30px;
    //   padding: 0 !important;
    // }
    // .el-button {
    //   color: #919191;
    // }
    // .el-button + .el-button {
    //   margin-left: 20px;
    // }
  }

  .el-pagination {
    margin-top: 20px;
  }

  .cellCustomer {
    height: 32px;
    text-align: center;
    line-height: 32px;
    padding: 0;
    color: #969696;

    .el-button {
      color: #919191;
    }
  }

  .headerCellCustomer {
    color: #505050;
    background-color: #f9f9f9;
  }
}
</style>